<template>
    <div>
        <span v-if="learner == 1">
            {{ session ? session.learner1.name : feedback.learner1.name }}
            <span v-if="showPositions">
                <span v-if="degree.simulation_role_2">
                    ({{ degree.simulation_role_1_name[degree.lang] }}
                    / {{ degree.simulation_role_2_name[degree.lang] }})
                </span>
                <span v-else>
                    ({{ degree.simulation_role_1_name[degree.lang] }})
                </span>
            </span>
        </span>
        <span v-else>
            {{ session ? session.learner2.name : feedback.learner2.name }}
            <span v-if="showPositions">
                <span v-if="degree.simulation_role_2">
                    ({{ degree.simulation_role_2_name[degree.lang] }}
                    / {{ degree.simulation_role_1_name[degree.lang] }})
                </span>
                <span v-else>
                    ({{ degree.simulation_role_1_name[degree.lang] }})
                </span>
            </span>
        </span>
    </div>
</template>

<script>
    export default {
        
        props: {

            session: {
                type: Object,
                default: null
            },

            feedback: {
                type: Object,
                default: null
            },

            degree: {
                type: Object,
                required: true
            },

            learner: {
                type: Number,
                default: 1
            },

            showPositions: {
                type: Boolean,
                default: true
            }
        }
    }
</script>

<style scoped>

    span {
        top: 0;
    }

</style>